import React from 'react';

import { InfoField } from '@occc/ui-design-system';
import { EarningMechanismPointSpendFragment } from '@occc/graphql';

interface IPointSpendProps {
  earningMechanism: EarningMechanismPointSpendFragment;
}
const formatPointCost = ({
  pointCost,
}: {
  pointCost: EarningMechanismPointSpendFragment['pointCost'];
}): string => `${pointCost}`;

export const PointSpend: React.FC<IPointSpendProps> = ({ earningMechanism }) => {
  return <InfoField label='Point cost' value={formatPointCost(earningMechanism)} />;
};
